// extracted by mini-css-extract-plugin
export default {"divider":"TermsPage_divider__5OQwB"};